<template>
  <div class="image-container" :class="[!imageSource ? 'img-empty': '', customClass]">
    <div class="image-wrapper">
      <img
        v-if="imageSource"
        :src="imageSource"
        :style="currentStyle" />
      <div class="empty-container" v-if="!imageSource">
        <div class="detail">No Preview Image</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ImageView',
  props: {
    source: {
      type: String,
    },
    customClass: {
      type: String,
    },
    defaultSource: {
      type: String,
    },
    currentStyle: {
      type: Object,
    },
  },
  computed: {
    imageSource() {
      if (this.source) {
        return this.source;
      }
      if (this.defaultSource) {
        return this.defaultSource;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';


.image-container {
  width: 100%;
  padding-top: 56.25%;

  position: relative;

  overflow: hidden;

  .image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
      width: 100%;
    }
  }

  &.image-1-1 {
    padding-top: 100%;
  }

  &.image-4-3 {
    padding-top: 75%;;
  }
}

.img-empty {
  background: $gray-500;
  position: relative;

  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    color: $gray-300;

    text-align: center;

    font-size: $font-size-sm;
    font-family: $font-family-base;
  }
}
</style>
